"use client";

import { useQueryClient } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { useDisconnect } from "wagmi";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { useAuth } from "@/context/auth";
import { useRouter } from "@/i18n/navigation";

export const NetworkSignOut = ({ onNavigate }: { onNavigate?: () => void }) => {
  const t = useTranslations("profile.links");
  const { isLoggedIn, logout } = useAuth();
  const { disconnect } = useDisconnect();
  const queryClient = useQueryClient();
  const router = useRouter();
  const [open, setOpen] = useState(false);
  if (!isLoggedIn) return null;
  const confirm = async () => {
    await logout();
    disconnect();
    queryClient.clear();
    setOpen(false);
    onNavigate?.();
    router.push("/");
  };
  return (
    <>
      <Button variant="light" className="w-full" onClick={() => setOpen(true)}>
        {t("logout")}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle>{t("logoutDialogTitle")}</DialogTitle>
            <DialogDescription>
              {t("logoutDialogDescription")}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="bordered" onClick={() => setOpen(false)}>
              {t("logoutDialogCancel")}
            </Button>
            <Button onClick={confirm}>{t("logoutDialogConfirm")}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
